import BoxContainer from './BoxContainer';

export default BoxContainer;
